export default function stampedController() {
  if (window.StampedIOSettings.hideIfEmpty) {
    function onProductRatingLoadedHideShowStampedWidget(event) {
      const reviewsCount = event.detail.count;

      if (reviewsCount === 0) {
        setTimeout(() => {
          const stampedMainWidget = document.getElementById('stamped-main-widget');

          if (!stampedMainWidget) {
            return;
          }

          stampedMainWidget.style.display = 'none';
        }, 0);
      }

      document.removeEventListener(`product-rating-loaded`, onProductRatingLoadedHideShowStampedWidget);
    }

    document.addEventListener(`product-rating-loaded`, onProductRatingLoadedHideShowStampedWidget);
  }

  // const stampedMainWidget = document.getElementById('stamped-main-widget');
  // if (stampedMainWidget) {
  //   function initStampedWidget() {
  //     stampedMainWidget.classList.add('stamped-widget-initialized');
  //   }

  //   (function (open) {
  //     XMLHttpRequest.prototype.open = function () {
  //       this.addEventListener('load', function () {
  //         if (
  //           this._url.includes('stamped.io/api/widget') &&
  //           !stampedMainWidget.classList.contains('stamped-widget-initialized')
  //         ) {
  //           initStampedWidget();
  //         }
  //       });

  //       return open.apply(this, arguments);
  //     };
  //   })(XMLHttpRequest.prototype.open);
  // }
}
